import React, { useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend } from 'recharts';
import { Card } from 'antd';
import Axios from '../../Axios';
import moment from 'moment'; // Usamos moment para formatear los meses

export default function GrowChart() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Axios.get('/analytics/growth')
      .then((response) => {
        setData(response.data);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Card loading={loading} title="Crecimiento últimos 12 meses" bordered={false} style={{ width: "100%", marginTop: 10 }}>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={data} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorFined" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="colorAttended" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
              <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#e0e0e0" strokeOpacity={0.1} />
          <XAxis 
            dataKey="month"
            tickFormatter={(month) => moment(month).format('MMM')} // 👈 Formatea '2024-04' como 'Abr'
          />
          <YAxis />
          <Tooltip labelFormatter={(label) => moment(label).format('MMMM YYYY')} />
          <Legend />
          <Area type="monotone" dataKey="fined" name="Multados" stroke="#8884d8" fillOpacity={1} fill="url(#colorFined)" />
          <Area type="monotone" dataKey="attended" name="No Multados" stroke="#82ca9d" fillOpacity={1} fill="url(#colorAttended)" />
        </AreaChart>
      </ResponsiveContainer>
    </Card>
  );
}
